import { Subject } from 'rxjs/Subject';
import { HttpService } from '../core/http/http.service';
import { Injectable } from '@angular/core';
import { IStorePhoto, IStoreDrawing, IStoreDocument, IContractDocument } from '../_entities';
import { IProfitLossDocument } from '../project/entities/all';

@Injectable()
export class FileService {

    public static fileUpdates$: Subject<any> = new Subject();

    constructor(private httpService: HttpService) {}


    public deleteFile(id: number): Promise<IStorePhoto[]> {
        return this.httpService.delete<IStorePhoto[]>(`api/file/${id}`);
    }

    //STORE PHOTOS

	public patchStorePhoto(id: number, data: any): Promise<IStorePhoto> {
        return this.httpService.patch<IStorePhoto>(`api/storephoto/${id}`, data);
    }


    //DRAWINGS

    public patchStoreDrawing(id: number, data: any): Promise<IStoreDrawing> {
        return this.httpService.patch<IStoreDrawing>(`api/storedrawing/${id}`, data);
    }


    // DOCUMENTS

    public patchStoreDocument(id: number, data: any): Promise<IStoreDocument> {
        return this.httpService.patch<IStoreDocument>(`api/storedocument/${id}`, data);
    }

	// CONTRACTS

	public patchContractDocument(contractId: number, id: number, data: any): Promise<IContractDocument> {
		return this.httpService.patch<IContractDocument>(`api/contract/${contractId}/document/${id}`, data);
	}

	// PROFIT LOSS

	public patchProfitLossDocument(id: number, data: any): Promise<IProfitLossDocument> {
		return this.httpService.patch<IProfitLossDocument>(`api/profitloss-document/${id}`, data);
	}



}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/_services/file.service.ts